import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {
  AgreementTokenModal,
  AgreementListFilters,
  CloneAgreementModal,
} from "@modules/agreements/components";
import { useAgreementsList } from "./controller";
import { useAgreementsListColumns } from "./columns";

export const AgreementList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    generateTokenModalRef,
    cloneModalRef,
    currentToken,
    isGenerating,
    tokenError,
    cloneTarget,
    handleCloseTokenModal,
    handleCloseCloneModal,
    handleGenerateToken,
    handleCloneAgreement,
    setSelectedRows,
    refetch,
    translate,
  } = useAgreementsList();

  const columns = useAgreementsListColumns({
    refetch,
    translate,
    handleGenerateToken,
    handleCloneAgreement,
    isGenerating,
  });

  const headerButtons = (
    <>
      <FilterDropdown
        initialValues={{
          search: "",
          active_agreement: "",
          is_admin: false,
          is_pdv: false,
        }}
      >
        <AgreementListFilters />
      </FilterDropdown>

      <CsvExportButton
        data={dataToExport}
        filename="agreements.csv"
        isDisabled={loading || !rows}
      />

      <CreateButton />
    </>
  );

  return (
    <List headerButtons={headerButtons}>
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        density="standard"
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <AgreementTokenModal
        modalRef={generateTokenModalRef}
        token={currentToken}
        isLoading={isGenerating}
        error={tokenError}
        onClose={handleCloseTokenModal}
      />

      {cloneTarget && (
        <CloneAgreementModal
          key={cloneTarget.id}
          modalRef={cloneModalRef}
          agreementId={cloneTarget.id}
          sourceName={cloneTarget.name}
          autoOpen
          onClose={handleCloseCloneModal}
        />
      )}
    </List>
  );
});
